import { render, staticRenderFns } from "./OSideBar.vue?vue&type=template&id=4167eb17&scoped=true"
import script from "./OSideBar.vue?vue&type=script&lang=js"
export * from "./OSideBar.vue?vue&type=script&lang=js"
import style0 from "./OSideBar.vue?vue&type=style&index=0&id=4167eb17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167eb17",
  null
  
)

export default component.exports